import { render, staticRenderFns } from "./BetMatch.vue?vue&type=template&id=611a3c4b&scoped=true&"
import script from "./BetMatch.vue?vue&type=script&lang=js&"
export * from "./BetMatch.vue?vue&type=script&lang=js&"
import style0 from "./BetMatch.vue?vue&type=style&index=0&id=611a3c4b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a3c4b",
  null
  
)

export default component.exports